"use client";

import React from "react";

//type
import type { InputGroupProps } from "@/types";

//Style
import * as S from "./styles";

interface InputSearchProps extends Omit<InputGroupProps, "onChange"> {
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: any } },
  ) => void;
  disabled?: boolean;
  validation?: {
    type: "error" | "success";
    message: string;
  };
}

const InputSearch = React.forwardRef<HTMLInputElement, InputSearchProps>(
  (
    {
      className,
      icon,
      placeholder,
      name,
      value,
      onChange,
      disabled,
      validation,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        <S.InputGroup className={className}>
          <S.IconComponent name={icon} />
          <S.InputComponent
            ref={ref}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={!!disabled}
            {...rest}
          />
        </S.InputGroup>
        {validation?.type === "error" && (
          <S.ErrorMessage>{validation.message}</S.ErrorMessage>
        )}
      </>
    );
  },
);

InputSearch.displayName = "InputSearch";

export default InputSearch;
